import { mergeStyles, mergeStyleSets } from '@uifabric/merge-styles'
import React from 'react'

const style = mergeStyleSets({
  main: {
    'div': {
      marginBottom: 16,
    }
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
  }
})

export const Instructions = () => {
    return (
      <div className={style.main}>
        <div className={style.title}>How to use:</div>
        <div>1. Enter text by either selecting a preset above, pasting in your own text from the clipboard (with Ctrl-V), or typing it in manually.</div>
        <div>2. Press the Practice button below, or press Ctrl-R, to start the session timer.</div>
        <div>3. All the text you input will go grey and you must type it correctly until all characters are black. If a character is in red, you mis-typed and must delete and type it again.</div>
        <div>4. The timer will stop once you type all the characters correctly. If you did better than last time that will be your new highscore.</div>
        <div>5. Press the Clear button below in order to remove these instructions and allow text input.</div>
        <div>Note: When pasting, 4 spaces will be converted to a tab; fancy quotes will be converted to normal quotes; all whitespace will be preserved and not trimmed or removed, you must manually format that outside the app then paste it in when it's to your liking.</div>
      </div>
    )
  }